import { Autocomplete, Box, Modal, TextField } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { SxProps } from '@mui/system';
import { FC, useEffect, useState } from "react";
import { IIKAMap, IInputSuggestionsList } from "../../../../reducer/mappingFiles/_interfaces";
import { useDispatch, useSelector } from "react-redux";
import { inputSuggestions, ikaMapCountries } from "../../../../reducer/mappingFiles/selectors";
import * as constants from "../constants";
import { ICountry } from "../../../../reducer/General/_interfaces";
import { saveItem } from "../../../../actions/mappingFiles/ikamapActions";


type IProps = {
    open:boolean;
    selectedItem?:IIKAMap | null;
    toggleOpen: () => void;
}


const style: SxProps<Theme> = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '87vw',
    height: '94vh',
    bgcolor: 'background.paper',
    border: '2px solid FFFFFF',
    boxShadow: 24,
    borderRadius: 8,
    p: '1.5vh 3vh',
}

export const EditModal:FC<IProps> = ({open, toggleOpen, selectedItem}) => {
    const dispatch = useDispatch();

    const countries = useSelector(ikaMapCountries);
    const filters:IInputSuggestionsList = useSelector(inputSuggestions);

    const [selectedCountry, setSelectedCountry] = useState<ICountry | null>(null);
    const [custPlanningLevel, setCustPlanningLevel] = useState<string>(selectedItem?.cust_planning_level || '');
    const [custPlanningLevelName, setCustPlanningLevelName] = useState<string>(selectedItem?.cust_planning_level_name || '');
    const [gkc, setGkc] = useState<string>(selectedItem?.gkc || '');
    const [buyngGroupCustName, setBuyngGroupCustName] = useState<string>(selectedItem?.buyng_group_cust_name || '');
    
    const [reason, setReason] = useState<string>(selectedItem?.reason || '');


    useEffect(() => {
        setCustPlanningLevel(selectedItem?.cust_planning_level || '');
        setCustPlanningLevelName(selectedItem?.cust_planning_level_name || '');
        setGkc(selectedItem?.gkc || '');
        setBuyngGroupCustName(selectedItem?.buyng_group_cust_name || '');
        setSelectedCountry(selectedItem ? {
            comp_code: '',
            id: selectedItem.country_code,
            title: selectedItem.country,
        } : null);
    }, [selectedItem, open]);

    const submitForm = () => {
        if (selectedCountry && custPlanningLevel && custPlanningLevelName && gkc && buyngGroupCustName) {
            const item = {
                id: selectedItem?.id || null,
                country: selectedCountry.title,
                country_code: selectedCountry.id,
                cust_planning_level: custPlanningLevel,
                cust_planning_level_name: custPlanningLevelName,
                gkc,
                buyng_group_cust_name: buyngGroupCustName,
                reason,
            }

            toggleOpen();
            dispatch(saveItem(item, 'formmap'));
        }
    }

    return (
        <Modal
            open={open}
            onClose={toggleOpen}
            onBackdropClick={toggleOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="brand-category-modal-form-header">
                    <p>
                        {selectedItem
                            ?  `Cust. Planning Level: ${selectedItem.cust_planning_level}`
                            : "Add New Entry"}
                    </p>
                    <div className="brand-category-modal-form-close-button" onClick={toggleOpen}>
                        X
                    </div>
                </div>
                <div className="brand-category-modal-form-body">
                    <div className="brand-category-modal-form-input-container row m-0">
                        <div className="d-grid" style={{
                            gridTemplateColumns: "repeat(3, 1fr)",
                            gap: 16
                        }}>
                            
                            <div className="brand-category-modal-form-input col-3 p-0 w-100">
                                <div style={{ display: "flex" }}>
                                    <p className="m-0 mb-2">{constants.country_label}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                <Autocomplete
                                    id="country"
                                    autoHighlight
                                    onChange={(event, newValue) => setSelectedCountry(newValue)}
                                    value={selectedCountry}
                                    options={countries}
                                    getOptionLabel={(option:ICountry) => option.title}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </div>

                            <div className="brand-category-modal-form-input col-3 p-0 w-100">
                                <div style={{ display: "flex" }}>
                                    <p className="m-0 mb-2">{constants.cust_planning_level_label}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                <Autocomplete
                                    id="cust_planning_level"
                                    freeSolo
                                    onInputChange={(event, newInputValue) => setCustPlanningLevel(newInputValue)}
                                    value={custPlanningLevel}
                                    options={filters.cust_planning_level.map(({title}) => (title))}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </div>

                            
                            <div className="brand-category-modal-form-input col-3 p-0 w-100">
                                <div style={{ display: "flex" }}>
                                    <p className="m-0  mb-2">{constants.cust_planning_level_name_label}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                <Autocomplete
                                    id="cust_planning_level_name"
                                    freeSolo
                                    onInputChange={(event, newInputValue) => setCustPlanningLevelName(newInputValue)}
                                    value={custPlanningLevelName}
                                    options={filters.cust_planning_level_name.map(({title}) => (title))}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </div>

                            
                            <div className="brand-category-modal-form-input col-3 p-0 w-100">
                                <div style={{ display: "flex" }}>
                                    <p className="m-0 mb-2">{constants.gkc_label}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                <Autocomplete
                                    id="gkc"
                                    freeSolo
                                    onInputChange={(event, newInputValue) => setGkc(newInputValue)}
                                    value={gkc}
                                    options={filters.gkc.map(({title}) => (title))}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </div>

                            
                            <div className="brand-category-modal-form-input col-3 p-0 w-100">
                                <div style={{ display: "flex" }}>
                                    <p className="m-0 mb-2">{constants.buyng_group_cust_name_label}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                <Autocomplete
                                    id="buyng_group_cust_name"
                                    freeSolo
                                    onInputChange={(event, newInputValue) => setBuyngGroupCustName(newInputValue)}
                                    value={buyngGroupCustName}
                                    options={filters.buyng_group_cust_name.map(({title}) => (title))}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="brand-category-modal-form-footer row m-0">
                    <div className="brand-category-modal-form-input col-6">
                        <div style={{ display: "flex" }}>
                            <p className="m-0">Comment</p><p style={{ color: "#E61C2A" }}>*</p>
                        </div>

                        <textarea className="brand-category-text-input-box"
                            style={{ width: "100%" }}
                            rows={4} cols={50}
                            name="reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </div>
                    <div className="brand-category-modal-form-input col-6">
                        <div style={{ float: "right" }}>
                            <button className="brand-category-form-modal-cancel-button mt-3" onClick={toggleOpen}>Cancel</button>
                            <button className="brand-category-form-modal-submit-button mt-3" onClick={submitForm}>Submit</button>
                        </div>
                    </div>

                </div>
            </Box>
        </Modal>
    );
}